import React, { useMemo, useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label ,FormGroup, Button, CardTitle, Modal, ModalHeader, ModalBody, Table} from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import Select from 'react-select'
import axios from '../../axios';
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import Numeral from 'react-numeral';
import { Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
      display:'flex',
      flexDirection:'column',
    },
  }));

function DelayShipment() {


    const [companyhelp,setcompanyhelp]=useState([])
    const [Companyvalue, setCompanyvalue] = useState(JSON.parse(localStorage.getItem('company')))
    const [buyerhelp,setbuyerhelp]=useState([])
    const [buyervalue,setbuyervalue]=useState({label:"All",value:"0"})
    const [stylehelp,setstylehelp]=useState([])
    const [stylevalue,setstylevalue]=useState({label:"All",value:0})
    const [fromdate, setfromdate] = useState(new Date())
    const [todate, settodate] = useState(new Date())
    const [showtabel, setshowtabel] = useState(false)

    //nodatafound
    const [delayshipmenterr, setdelayshipmenterr] = useState(false)
    const [delayshipmenterr1, setdelayshipmenterr1] = useState(false)

    const classes = useStyles();
    const [Spinner, setSpinner] = useState(false)

    //tabledata
    const[tabledata,settabledata]=useState([])

    useEffect(() => {
        company()
        buyer()

        var date =  new Date()
      
        var firstday =  new Date(date.getFullYear(), date.getMonth(),1)
       
        var lastday = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate());
        setfromdate(moment(firstday).format('YYYY-MM-DD'))
        settodate(moment(lastday).format('YYYY-MM-DD'))
        setCompanyvalue(JSON.parse(localStorage.getItem('company')))
    }, [])


    const company=async()=>{
        await axios.instance.get("CompanyHelp/GetCompany")
        .then((res)=>{
            const data=res.data
            const option=data.map(row=>({
                "label":row.company,
                "value":row.companyId
            }))
            console.log(option,"companyhelp");
            setcompanyhelp(option)  
        }) 
    }

    const buyer=async()=>{
        await axios.instance.get("/BuyerHelp/BookedBuyerHelp")
        .then((res)=>{
            const data =res.data
            console.log(data,"buyerhelp")
            const option=data.map(row=>({
                "label":row.buyer,
                "value":row.buyerId
            }))
            // console.log(option,"buyerhelp")
            option.push({label:"All",value:0})
            setbuyerhelp(option)
        })
    }

    const style=async(value)=>{
        await axios.instance.get(`/StyleNoHelp/IpoNoStyle?buyerid=${value}&companyid=${Companyvalue.value}`)
        .then((res)=>{
            const data =res.data
            // console.log(res.data)
            const option=data.map(row=>({
                "label":row.ipoNo,
                 "value":row.ipoNo
            }))
            console.log(option,"ss")
            option.push({label:"All",value:0})
            setstylehelp(option)
        })
    }

    const column = useMemo(
        () => [
          {
            Header: "Buyer",
            accessor:(row=>row.buyer),
            accessor:'buyer',
            filterable: false,
    
          },
          {
            Header: "Ipo No",
            accessor: (row=>(<div className='text-center'>{row.ipoNo}</div>)),
            filterable: false,
    
          },
          {
            Header: "Style",
            accessor: (row=>(<div className='text-start'>{row.style}</div>)),
            filterable: false,
    
          },
          {
            Header: "Order No",
            accessor: (row=>(<div className='text-center'>{row.orderNo}</div>)),
            filterable: false,
          },
          {
            Header: "Order Date",
            accessor: (row)=>(
              (row.orderDate)
            ),
            filterable: false,
          },
          {
            Header: "Ship Date",
            accessor: (row)=>(
              (row.shipDate)
            ),
            filterable: false,
          },
          {
            Header: "Qty",
          accessor:(row=>(<div className='text-center'>{row.qty}</div>)),
            filterable: false,
          
          },
          {
            Header: "Ship Qty",
            accessor: (row=>(<div className='text-center'>{row.shipQty}</div>)),
            filterable: false,
          
          },
          {
            Header: "Shipping Status",
            accessor: row=>row.shippingStatus === "NotShipped" ? <span class="badge bg-danger tex-start">Not Shipped</span> :  <span class="text-start badge bg-warning">Partial</span>,
            filterable: false,
          
          },
          {
            Header: "Delay Days",
            accessor: (row=>(<div className='text-center'>{row.delayedDays}</div>)),
            filterable: false,
          
          },
        ]
      )

    const viewdata=async()=>{
        setshowtabel(true);
        setSpinner(true)
        await axios.instance.get(`/DelayShipment/GetOrders?companyid=${Companyvalue.value}&buyerid=${buyervalue.value}&ipono=${stylevalue.value}&fromdate=${moment(fromdate).format('YYYYMMDD')}&todate=${moment(todate).format('YYYYMMDD')}`)
        .then((res)=>{
            console.log(res.data.query)
            res.data.query==""? (settabledata([]) || setdelayshipmenterr(true)) : settabledata(res.data.query)
        })
        setTimeout(() => {
            setSpinner(false)
          }, 2000);
    }

  return (
    <React.Fragment>
        <div className="account-pages my-5 pt-5 m-3 pt-sm-5">
            <Container fluid={true}>
                <Card style={{backgroundColor:"white"}}>
                    <CardBody className="p-4">
                        <Row>
                            <Col>
                                <Breadcrumb title="Report" breadcrumbItem="Delay Shipment" />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='excompany'>
                                        Company
                                    </Label>         
                                    <Select 
                                        onChange={(value) => {
                                            console.log(value)
                                            setCompanyvalue(value)
                                        }}
                                        value={Companyvalue}
                                        options={companyhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='exbuyer'>
                                        Buyer
                                    </Label>         
                                    <Select
                                        name="Buyer"
                                        value={buyervalue}
                                        onChange={(value)=>{
                                            setbuyervalue(value)
                                            style(value.value)
                                        }}
                                        options={buyerhelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='exstyleno'>
                                    IPO No
                                    </Label>         
                                    <Select
                                        name="Style No"
                                        value={stylevalue}
                                        onChange={(value)=>{
                                            console.log(value.value[0],"stylevalue")
                                            console.log(value.label,"stylelabel")
                                            setstylevalue(value) 
                                        }}
                                        options={stylehelp}
                                        styles={{
                                            menuPortal: (provided, state) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            }),
                                            menu: (provided, state) => ({
                                            ...provided,
                                            height: 'auto',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='exfromdate'>
                                        From Date
                                    </Label>         
                                    <Input id='exfromdate' name='Date' type='date' 
                                        value={fromdate}
                                        onChange={(e)=> setfromdate(e.target.value)}
                                        min="1900-01-01" maxLength='4' max="9999-12-31"
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='4'>
                                <FormGroup> 
                                    <Label for='extodate'>
                                        To Date
                                    </Label>         
                                    <Input id='extodate'
                                        onChange={(e)=> settodate(e.target.value)}
                                        min="1900-01-01" maxLength='4' max="9999-12-31"
                                        value={todate}
                                        name='ToDate' type='date' />
                                </FormGroup>
                            </Col>
                            <Col sm='12' md='12' lg='4' className="mt-auto mb-auto">
                                <Button size='md' className="mx-1 w-lg mt-2" style={{backgroundColor:'#0E21A0',color:'white',fontWeight:'bolder'}} onClick={()=>{viewdata()}}>View</Button>
                                {/* <Button size ="sm"  style={{backgroundColor:'#00AC47',borderColor:'#00AC47'}}    className="btn btn-sm btn-primary w-lg"  onClick={()=>{console.log('first')}}><i className="mdi mdi-microsoft-excel font-size-18 align-middle me-1 "></i>Excel</Button> */}
                            </Col>
                        </Row>
                        {showtabel && (
                        <TableContainer
                            columns={column}
                            data={tabledata}
                            isGlobalFilter={true}
                            isAddTableBorderStrap={true}
                        />
                        )}
                    </CardBody>
                </Card>
            </Container>

            {delayshipmenterr ? (
                <SweetAlert
                    title="No Data Found"
                    timeout={2000}
                    style={{
                    position: "absolute",
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setdelayshipmenterr(false);
                    }}
                ></SweetAlert>
                ) : null}

            {delayshipmenterr1 ? (
                <SweetAlert
                    title="Invalid Date"
                    timeout={2000}
                    style={{
                    position: "absolute",
                        justifyContent:'center',
                        alignItems:'center'
                    }}
                    showCloseButton={false}
                    showConfirm={false}
                    warning
                    onConfirm={() => {
                        setdelayshipmenterr1(false);
                    }}
                ></SweetAlert>
                ) : null}

        </div>
    </React.Fragment>
  )
}

export default DelayShipment